import { Component } from '@angular/core';
import { ToastElement, ToastElementWithID } from "./model/toast-element";
import { UnsubscribeOnDestroyAdapter } from '../../adapters/unsubscibe-on-destroy.adapter';
import { slideIn, slideOut } from '../../animations';
import { ToastService } from '../../../services/toast.service';


@Component({
  selector: 'psc-toast',
  templateUrl: './toast.component.html',
  animations: [
    slideIn,
    slideOut,
    ],
})
export class ToastComponent extends UnsubscribeOnDestroyAdapter {

  toastList: ToastElementWithID[] = [];

  currentToastId = 0;

  constructor(
    private toastService: ToastService,
  ) {
    super();
    this.subs.sink = this.toastService.toastAddedObservable$.subscribe((toast) => this.addToast(toast));
  }

  removeToast(id: number) {
    this.toastList.splice(this.toastList.findIndex(toast => toast.id === id), 1);
  }

  private addToast(toast: ToastElement) {
    const elementId = this.currentToastId++;
    this.toastList.push({id: elementId, ...toast});
    setTimeout(() => {
      this.removeToast(elementId);
    }, 5000);
  }
}
